// Keeps a golfer logged in to the offers page on this device after they enter their access code, so
// closing the browser or app (which loses the router state) doesn't send them back to the code.
// The login lasts until they press Logout, or 90 days without opening the offers page.

const KEY = "vsga_offers_session";
const MAX_IDLE_MS = 90 * 24 * 60 * 60 * 1000;

type Saved = { contactId: string; lastSeen: number };

export const saveOffersSession = (contactId: string) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ contactId, lastSeen: Date.now() } as Saved));
  } catch {
    // Storage blocked (private mode etc.): the golfer just logs in again next time
  }
};

export const loadOffersSession = (): string | null => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as Partial<Saved>;
    if (!saved?.contactId || !saved.lastSeen || Date.now() - saved.lastSeen > MAX_IDLE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return String(saved.contactId);
  } catch {
    return null;
  }
};

export const clearOffersSession = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
};
